import { HTTPError } from 'services/api/entities';
import { RequestStatus } from './types';
import type { RequestState, PayloadAction } from './types';

type PayloadResponse = {
  response: unknown;
};

type PayloadError = {
  error: HTTPError;
};

export const initialState: RequestState<unknown> = {
  loading: false,
  error: null,
  response: null,
};

const hasResponse = (
  obj: PayloadAction<unknown>
): obj is PayloadAction<PayloadResponse> => {
  const objectToTest = obj as PayloadAction<PayloadResponse>;
  if (!objectToTest.type || !objectToTest.payload) return false;
  const { response } = objectToTest.payload;
  return response !== undefined && response !== null;
};

const hasError = (
  obj: PayloadAction<unknown>
): obj is PayloadAction<PayloadError> => {
  const objectToTest = obj as PayloadAction<PayloadError>;
  if (!objectToTest.type || !objectToTest.payload) return false;
  const { error } = objectToTest.payload;
  return error !== undefined && error !== null;
};

const requestReducer = (
  state: RequestState<unknown>,
  action: PayloadAction<PayloadResponse | PayloadError>
): RequestState<unknown> => {
  if (action.type && action.type === RequestStatus.Loading) {
    return {
      response: null,
      loading: true,
      error: null,
    };
  }

  if (hasResponse(action) && action.type === RequestStatus.Success) {
    const payload = action.payload as PayloadResponse;
    return {
      response: payload.response,
      loading: false,
      error: null,
    };
  }

  if (hasError(action) && action.type === RequestStatus.Error) {
    const payload = action.payload as PayloadError;
    return {
      response: null,
      loading: false,
      error: payload.error,
    };
  }

  return state;
};

export default requestReducer;
